import AdminController from "./AdminController";
import AuthController from "./AuthController";
import UserController from "./UserController";
import FigureController from "./FigureController";
import CompanyController from "./CompanyController";
import ReportController from "./ReportController";
import FigureDatabaseController from "./FigureDatabaseController";
import MarketController from "./MarketController";
import ShelfController from "./ShelfController";
import GroupController from "./GroupController";
import FollowController from "./FollowController";
import PostController, { FeedController, CommentController, HashtagController } from "./PostController";
import CommentFeedController from "./CommentFeedController";
import ProfileStatsController from "./ProfileStatsController";
import ProfileViewController from "./ProfileViewController";
import ThemeController, { useThemeController } from "./ThemeController";
import WikiController from "./WikiController";
import FigureTagController from "./FigureTagController";
import RelationshipController from "./RelationshipController";
import LocationsController from "./LocationsController";
import UniversalCommentsController from "./UniversalCommentsController";

export { 
  AdminController, 
  AuthController, 
  UserController, 
  FigureController, 
  CompanyController, 
  ReportController, 
  FigureDatabaseController,
  MarketController,
  ShelfController, 
  GroupController, 
  PostController, 
  FeedController, 
  CommentController,
  CommentFeedController,
  HashtagController, 
  ProfileStatsController,
  ProfileViewController,
  ThemeController,
  useThemeController,
  FollowController,
  FigureTagController,
  RelationshipController,
  LocationsController,
  UniversalCommentsController,
};

const CONTROLLERS = {
  UserController,
  AuthController,
  AdminController,
  CompanyController,
  FigureController,
  FigureDatabaseController,
  MarketController,
  ReportController,
  ShelfController,
  GroupController,
  PostController,
  FeedController,
  CommentController,
  CommentFeedController,
  HashtagController,
  FollowController,
  ProfileStatsController,
  ProfileViewController,
  ThemeController,
  WikiController,
  FigureTagController,
  RelationshipController,
  LocationsController,
  UniversalCommentsController,
}

export default CONTROLLERS;